<div id="layout" class="theme-cyan">
  <app-chat-leftmenu></app-chat-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3" id="show-user-detail">

    <!-- chat body -->
    <div class="chat-body">

      <!-- Chat: Header -->
      <div class="chat-header border-bottom py-xl-4 py-md-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- Chat photo -->
            <div class="col-6 col-xl-4">
              <div class="media">
                <div class="avatar me-3 show-user-detail" (click)="slidechat()" data-bs-toggle="tooltip"
                  title="Group details">
                  <div class="avatar rounded-circle no-image timber">
                    <span>UD</span>
                  </div>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h6 class="text-truncate mb-0 me-auto">UI-Design Group</h6>
                  </div>
                  <div class="text-truncate">4 members participants</div>
                </div>
              </div>
            </div>

            <!-- Chat toolbar -->
            <div class="col-6 col-xl-8 text-end">

              <ul class="nav justify-content-end">
                <li class="nav-item list-inline-item d-none d-md-block me-3">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-sm-block me-3">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" title="videocam"
                    data-bs-toggle="tooltip" title="Video Call">
                    <i class="zmdi zmdi-videocam zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-sm-block me-3">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" title="Call" data-bs-toggle="tooltip"
                    title="Call">
                    <i class="zmdi zmdi-phone-forwarded zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item add-user-btn">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" title="Add Account"
                    data-bs-toggle="tooltip" title="Add new user" (click)="slideuserchat()">
                    <i class="zmdi zmdi-account-add zmdi-hc-lg"></i>
                  </a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">Search chat</a>
                      <a class="dropdown-item" href="javascript:void(0)">Attache Image</a>
                      <a class="dropdown-item" href="javascript:void(0)">Video call</a>
                      <a class="dropdown-item" href="javascript:void(0)">Call</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div> <!-- .row end -->

        </div>
      </div>

      <!-- Chat: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Chat: Content-->
      <div class="chat-content">
        <div class="container-fluid">

          <ul class="list-unstyled py-4">

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <img class="avatar sm rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <span class="date-time text-muted">Jason, 7:19 PM</span>

                <div class="message-row d-flex align-items-center">

                  <!-- Message: content -->
                  <div class="message-content p-3">
                    Hello @all, <br> How are you?
                  </div>

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted ms-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                </div>
              </div>

            </li>

            <!-- Message: Right -->
            <li class="d-flex message right">

              <div class="message-body">
                <span class="date-time text-muted">7:19 PM <i class="zmdi zmdi-check-all text-primary"></i></span>

                <div class="message-row d-flex align-items-center justify-content-end">

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted me-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                  <!-- Message: content -->
                  <div class="message-content border p-3">
                    Start new project
                  </div>

                </div>
                <div class="message-row d-flex align-items-center justify-content-end">

                  <div class="message-content border p-3">
                    It is a long established fact that a reader will be distracted.
                    <div class="card mt-2">
                      <div class="card-body">
                        <span class="mb-2 badge bg-success rounded-0 label-absolute">Active</span>
                        <h6 class="mt-2"><a href="app-project-detail.html">Polarised stable frame</a></h6>
                        <span class="text-muted">Last Edited by: Caden Brakus <br>Saturday, 12 September, 2020</span>
                        <div class="mt-3 mb-3">
                          <div class="mb-1 progress" style="height: 3px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="5" aria-valuemin="0"
                              aria-valuemax="100" style="width: 5%;"></div>
                          </div>
                          <small>Tasks Completed: <span class="text-inverse">1/23</span></small>
                        </div>
                        <div class="d-flex">
                          <a href="javascript:void(0)" class="align-self-center me-2"><i
                              class="zmdi zmdi-star-outline"></i></a>
                          <span class="align-self-center">20 Dec, Fri, 2020</span>
                          <div class="align-self-center ms-auto">
                            <div class="dropdown" dropdown placement="bottom right">
                              <a class="btn btn-sm btn-link py-0 text-muted dropdown-toggle" ref="javascript:void(0)"
                                dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                  class="zmdi zmdi-settings"></i></a>
                              <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                role="menu" aria-labelledby="button-alignment">
                                <a class="dropdown-item" href="javascript:void(0)">Action</a>
                                <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </li>

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <img class="avatar sm rounded-circle b-orange" src="../assets/images/xs/avatar6.jpg" alt="avatar">
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <span class="date-time text-muted">Martin, 7:19 PM</span>

                <div class="message-row d-flex align-items-center">

                  <!-- Message: content -->
                  <div class="message-content p-3">
                    Hello, Jason
                  </div>

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted ms-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                </div>
              </div>

            </li>

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <img class="avatar sm rounded-circle b-purple" src="../assets/images/xs/avatar1.jpg" alt="avatar">
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <span class="date-time text-muted">Terry, 7:19 PM</span>

                <div class="message-row d-flex align-items-center">

                  <!-- Message: content -->
                  <div class="message-content p-3">
                    Hello, Jason
                  </div>

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted ms-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                </div>
              </div>

            </li>

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <img class="avatar sm rounded-circle b-pink" src="../assets/images/xs/avatar4.jpg" alt="avatar">
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <span class="date-time text-muted">Michelle, 7:19 PM</span>

                <div class="message-row d-flex align-items-center">

                  <!-- Message: content -->
                  <div class="message-content p-3">
                    Hello, please find attachment, let me know if any changes.
                    <div class="attachment">
                      <div class="media mt-2">
                        <div class="avatar me-2">
                          <div class="avatar rounded no-image orange">
                            <i class="zmdi zmdi-collection-pdf"></i>
                          </div>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h6 class="text-truncate mb-0">Design file.pdf</h6>
                          <span class="file-size">2.7 mb</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted ms-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                </div>

              </div>

            </li>

            <!-- Message: Right -->
            <li class="d-flex message right">

              <div class="message-body">
                <span class="date-time text-muted">7:19 PM <i class="zmdi zmdi-check-all text-primary"></i></span>

                <div class="message-row d-flex align-items-center justify-content-end">

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted me-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                  <!-- Message: content -->
                  <div class="message-content border p-3">
                    Hello, David
                  </div>

                </div>
                <div class="message-row d-flex align-items-center justify-content-end">

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted me-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                  <!-- Message: content -->
                  <div class="message-content border p-3">
                    We have send some project shot, please review
                    <div class="attachment right-file">
                      <img class="rounded mt-1" src="../assets/images/image-file/one-page-work-1.jpg" alt="" />
                      <img class="rounded mt-1" src="../assets/images/image-file/one-page-work-2.jpg" alt="" />
                      <img class="rounded mt-1" src="../assets/images/image-file/one-page-work-3.jpg" alt="" />
                    </div>
                  </div>

                </div>
              </div>

            </li>

            <!-- Message: Divider -->
            <li class="d-flex message divider mt-xl-5 mt-md-3 mb-xl-5 mb-md-3">
              <small class="text-muted">Today</small>
            </li>
            <!-- End message divider -->

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <img class="avatar sm rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <span class="date-time text-muted">Jason, 7:19 PM</span>

                <div class="message-row d-flex align-items-center">

                  <!-- Message: content -->
                  <div class="message-content p-3">
                    Thank you for the update!
                  </div>

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted ms-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                </div>
                <div class="message-row d-flex align-items-center">

                  <!-- Message: content -->
                  <div class="message-content p-3">
                    <div class="mb-1 progress" style="height: 3px;">
                      <div class="progress-bar" role="progressbar" aria-valuenow="5" aria-valuemin="0"
                        aria-valuemax="100" style="width: 5%;"></div>
                    </div>
                    <small>Tasks Completed: <span class="text-inverse">1/23</span></small>
                  </div>

                  <!-- Message: dropdown -->
                  <div class="dropdown" dropdown placement="bottom right">
                    <a class="text-muted ms-1 p-2 text-muted dropdown-toggle" href="javascript:void(0)" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more-vert"></i>
                    </a>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0)">Edit</a>
                      <a class="dropdown-item" href="javascript:void(0)">Share</a>
                      <a class="dropdown-item" href="javascript:void(0)">Delete</a>
                    </div>
                  </div>
                  <!-- End Message: dropdown -->

                </div>
              </div>

            </li>

          </ul>

        </div>
      </div>

      <!-- Chat: Footer -->
      <div class="chat-footer border-top py-xl-4 py-lg-2 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-12">
              <div class="input-group align-items-center">

                <!-- message textarea -->
                <input type="text" class="form-control border-0 pl-0" placeholder="Type your message...">

                <!-- message right icon-->
                <div class="input-group-append d-none d-sm-block">
                  <span class="input-group-text border-0">
                    <button class="btn btn-sm btn-link text-muted" data-bs-toggle="tooltip" title="Refresh"
                      type="button"><i class="zmdi zmdi-refresh font-22"></i></button>
                  </span>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text border-0">
                    <button class="btn btn-sm btn-link text-muted" data-bs-toggle="tooltip" title="Smaily"
                      type="button"><i class="zmdi zmdi-mood font-22"></i></button>
                  </span>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text border-0">
                    <button class="btn btn-sm btn-link text-muted" data-bs-toggle="tooltip" title="Attachment"
                      type="button"><i class="zmdi zmdi-attachment font-22"></i></button>
                  </span>
                </div>

                <!-- message send btn-->
                <div class="input-group-append">
                  <span class="input-group-text border-0 pr-0">
                    <button type="submit" class="btn btn-primary">
                      <span class="d-none d-md-inline-block me-2">Send</span>
                      <i class="zmdi zmdi-mail-send"></i>
                    </button>
                  </span>
                </div>

              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>

    </div>
    <!-- End chat body -->

    <!-- Chat: user details -->
    <div class="user-detail-sidebar py-xl-4 py-3 px-xl-4 px-3">
      <div class="d-flex flex-column">
        <div class="header border-bottom pb-4 d-flex justify-content-between">
          <div>
            <h6 class="mb-0 fw-bold">Group Activity</h6>
            <span class="text-muted">4 Participants</span>
          </div>
          <div>
            <button class="btn btn-link text-muted close-chat-sidebar" type="button" (click)="closechatside()"><i
                class="zmdi zmdi-close"></i></button>
          </div>
        </div>

        <div class="body">
          <ul class="nav nav-tabs nav-overflow page-header-tabs">
            <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                [ngClass]="{'active': projectTab}">Project</a></li>
            <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                [ngClass]="{'active': fileTab}">File
                Manager</a></li>
            <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('3')"
                [ngClass]="{'active': groupTab}">Group
                Details</a></li>
          </ul>
          <div class="tab-content py-3" id="myTabContent">
            <div class="tab-pane fade show active" id="GroupChat-Project" [ngClass]="{'show active': projectTab}">
              <div class="card mb-3">
                <div class="card-body">
                  <span class="mb-2 badge bg-success rounded-0 label-absolute">Active</span>
                  <h6 class="mt-2"><a href="javascript:void(0)">Polarised stable frame</a></h6>
                  <span class="text-muted">Last Edited by: Caden Brakus <br>Saturday, 12 September, 2020</span>
                  <div class="mt-3 mb-3">
                    <div class="mb-1 progress" style="height: 3px;">
                      <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0"
                        aria-valuemax="100" style="width: 45%;"></div>
                    </div>
                    <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                  </div>
                  <div class="d-flex">
                    <a href="javascript:void(0)" class="align-self-center me-2"><i
                        class="zmdi zmdi-star-outline"></i></a>
                    <span class="align-self-center">20 Sep, Fri, 2020</span>
                    <div class="align-self-center ms-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a class="btn btn-sm btn-link py-0 text-muted dropdown-toggle" ref="javascript:void(0)"
                          dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                            class="zmdi zmdi-settings"></i></a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a class="dropdown-item" href="javascript:void(0)">Action</a>
                          <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                          <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-3">
                <div class="card-body">
                  <span class="mb-2 badge bg-secondary rounded-0 label-absolute">Paused</span>
                  <h6 class="mt-2"><a href="javascript:void(0)">Synergized upward-trending info-mediaries</a></h6>
                  <span class="text-muted">Last Edited by: Keely West <br>Saturday, 12 September, 2020</span>
                  <div class="mt-3 mb-3">
                    <div class="mb-1 progress" style="height: 3px;">
                      <div class="progress-bar" role="progressbar" aria-valuenow="23" aria-valuemin="0"
                        aria-valuemax="100" style="width: 23%;"></div>
                    </div>
                    <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                  </div>
                  <div class="d-flex">
                    <a href="javascript:void(0)" class="align-self-center me-2"><i
                        class="zmdi zmdi-star-outline"></i></a>
                    <span class="align-self-center">13 Sep, Fri, 2020</span>
                    <div class="align-self-center ms-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a class="btn btn-sm btn-link py-0 text-muted dropdown-toggle" ref="javascript:void(0)"
                          dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                            class="zmdi zmdi-settings"></i></a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a class="dropdown-item" href="javascript:void(0)">Action</a>
                          <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                          <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-primary btn-block" (click)="openModal(template)">Create New
                Project</button>
            </div>
            <!-- Create new project Modal popup -->

            <ng-template #template>
              <div class="modal-header">
                <h4 class="modal-title pull-left" style="font-family: 'IBM Plex Sans', sans-serif;">Create new Project
                </h4>

              </div>
              <div class="modal-body" style="font-family: 'IBM Plex Sans', sans-serif;">
                <form>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Project code</label>
                    <div class="col-sm-9">
                      <div class="input-group input-group-lg">
                        <input type="text" class="form-control" placeholder="Enter text here">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Project name</label>
                    <div class="col-sm-9">
                      <div class="input-group input-group-lg">
                        <input type="text" class="form-control" placeholder="Enter text here">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Start date</label>
                    <div class="col-sm-9">
                      <div class="input-group input-group-lg">
                        <input type="text" class="form-control project-date" placeholder="Start date" bsDatepicker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Due date</label>
                    <div class="col-sm-9">
                      <div class="input-group input-group-lg">
                        <input type="text" class="form-control project-date" placeholder="Due date" bsDatepicker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Select Team</label>
                    <div class="col-sm-9">
                      <div class="input-group input-group-lg">
                        <select class="custom-select form-control">
                          <option selected="">Select Team</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Enter Project Bio</label>
                    <div class="col-sm-9">
                      <textarea rows="4" class="form-control mb-3" placeholder="Enter Project Bio"></textarea>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer" style="font-family: 'IBM Plex Sans', sans-serif;">
                <button type="button" class="btn btn-secondary" (click)="modalRef.hide()"
                  style="background-color: #00028C;">Close</button>
                <button type="button" class="btn btn-primary" style="background-color: #21AA93;">Create</button>
              </div>
            </ng-template>

            <div class="tab-pane fade" id="GroupChat-file" [ngClass]="{'show active': fileTab}">
              <ul class="list-unstyled list-group list-group-flush">
                <li class="list-group-item attachment mb-1">
                  <div class="media mr-0">
                    <div class="avatar me-3">
                      <div class="avatar rounded no-image orange">
                        <i class="zmdi zmdi-collection-pdf"></i>
                      </div>
                    </div>
                    <div class="media-body overflow-hidden">
                      <h6 class="text-truncate mb-0">Design file.pdf</h6>
                      <div class="d-flex justify-content-between">
                        <span class="file-size">2.7 mb</span>
                        <span class="small">Martin, 7:19 PM</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item attachment mb-1">
                  <div class="media mr-0">
                    <div class="avatar me-3">
                      <div class="avatar rounded no-image cyan">
                        <i class="zmdi zmdi-file"></i>
                      </div>
                    </div>
                    <div class="media-body overflow-hidden">
                      <h6 class="text-truncate mb-0">Design file.psd</h6>
                      <div class="d-flex justify-content-between">
                        <span class="file-size">25.7 mb</span>
                        <span class="small">Terry, 12:19 PM</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item attachment mb-1">
                  <div class="media mr-0">
                    <div class="avatar me-3">
                      <div class="avatar rounded no-image green">
                        <i class="zmdi zmdi-file-text"></i>
                      </div>
                    </div>
                    <div class="media-body overflow-hidden">
                      <h6 class="text-truncate mb-0">Project detail.doc</h6>
                      <div class="d-flex justify-content-between">
                        <span class="file-size">3.7 mb</span>
                        <span class="small">Michelle, 11:05 AM</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="tab-pane fade" id="GroupChat-Details" [ngClass]="{'show active': groupTab}">
              <div class="d-flex justify-content-center mt-3">
                <div class="avatar xxl">
                  <div class="avatar xxl rounded-circle no-image timber">
                    <span>UD</span>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3 mb-5">
                <h4>UI-Design Group</h4>
                <span class="text-muted">the leap into electronic typesetting, remaining essentially unchanged.</span>
              </div>

              <!-- Chat: mutual friend list -->
              <ul class="chat-list">
                <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
                  <span>Members</span>
                  <div class="dropdown" dropdown placement="bottom right">
                    <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                      class="btn btn-link px-1 py-0 border-0 text-muted dropdown-toggle">
                      <i class="zmdi zmdi-filter-list"></i>
                    </button>
                    <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-basic">
                      <a href="javascript:void(0);" class="dropdown-item">Action</a>
                      <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                      <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="hover_action">
                    <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-eye"></i></button>
                    <button type="button" class="btn btn-link text-warning"><i class="zmdi zmdi-star"></i></button>
                    <button type="button" class="btn btn-link text-danger"><i class="zmdi zmdi-delete"></i></button>
                  </div>
                  <a href="javascript:void(0)" class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Jason Porter</h6>
                          </div>
                          <div class="text-truncate">last seen 2 hours ago</div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <div class="hover_action">
                    <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-eye"></i></button>
                    <button type="button" class="btn btn-link text-warning"><i class="zmdi zmdi-star"></i></button>
                    <button type="button" class="btn btn-link text-danger"><i class="zmdi zmdi-delete"></i></button>
                  </div>
                  <a href="javascript:void(0)" class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="../assets/images/xs/avatar6.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Martin Green</h6>
                          </div>
                          <div class="text-truncate">last seen 7 hours ago</div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <div class="hover_action">
                    <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-eye"></i></button>
                    <button type="button" class="btn btn-link text-warning"><i class="zmdi zmdi-star"></i></button>
                    <button type="button" class="btn btn-link text-danger"><i class="zmdi zmdi-delete"></i></button>
                  </div>
                  <a href="javascript:void(0)" class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Terry Carter</h6>
                          </div>
                          <div class="text-truncate">last seen 3 hours ago</div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <div class="hover_action">
                    <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-eye"></i></button>
                    <button type="button" class="btn btn-link text-warning"><i class="zmdi zmdi-star"></i></button>
                    <button type="button" class="btn btn-link text-danger"><i class="zmdi zmdi-delete"></i></button>
                  </div>
                  <a href="javascript:void(0)" class="card">
                    <div class="card-body">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Michelle Martin</h6>
                          </div>
                          <div class="text-truncate">last seen 5 hours ago</div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Chat: add new user to create a group chat -->
    <div class="addnew-user-sidebar py-xl-4 py-3 px-xl-4 px-3">
      <div class="d-flex flex-column">
        <div class="header border-bottom pb-4 d-flex justify-content-between">
          <div>
            <h6 class="mb-0 fw-bold">Add new member</h6>
            <span class="text-muted">Update your profile details</span>
          </div>
          <div>
            <button class="btn btn-link text-muted close-chat-sidebar" type="button" (click)="closeuserchatside()"><i
                class="zmdi zmdi-close"></i></button>
          </div>
        </div>

        <div class="body mt-4">

          <!-- Chat: user search -->
          <div class="form-group input-group-lg search mb-3">
            <i class="zmdi zmdi-search"></i>
            <input type="text" class="form-control" placeholder="Search...">
          </div>

          <!-- Chat: user list -->
          <ul class="chat-list">
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>A</span>
              <div class="dropdown">
                <a class="btn btn-link px-1 py-0 border-0 text-muted dropdown-toggle" href="javascript:void(0)"
                  role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" href="javascript:void(0)">Action</a>
                  <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                  <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                </div>
              </div>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Amelia Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 2 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar3.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Ava Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 1 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>C</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Charlotte Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Chloe Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 3 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar6.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Charles Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 2 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>D</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">David Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>M</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Michael Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Mohammad</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>T</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar9.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Tommy Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>

        </div>
      </div>
    </div>

  </div>
  <!-- Main Body: Content -->
</div>
